export default {"src":"/_next/static/media/ic-success.d9fe5827.svg","height":49,"width":49};